<template>
  <div
    class="navigation-container"
  >
    <a href="https://www.aclupa.org/">
      <img
        class="navigation-logo"
        src="@/assets/logo.svg"
      >
    </a>
    <div class="lang-container">
      <h3 class="sub-header">
        {{ lang[activeLang]['ACLU Pennsylvania Online Form To Request Legal Assistance'] }}
      </h3>
      <form-select
        id="lang-select"
        :input="{ title: 'Language', options: ['English', 'Español'] }"
        :active-lang="activeLang"
        @formUpdate="$emit('formUpdate', $event)"
      />
    </div>
  </div>
</template>

<script>
import FormSelect from './FormSelect.vue'

export default {
  name: 'Navigation',
  components: {
    FormSelect,
  },
  props: {
    activeLang: {
      type: String,
      default: "EN",
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.navigation-logo {
  width: 200px;
  height: 95px;
  color: black;
}

#lang-select {
  width: 124px;
  margin-bottom: 0em;
  margin-top: 0;
}

.navigation-container {
	display: flex;
	flex-direction: row;
	align-items: flex-start;
  flex-wrap: wrap;
  align-items: center;
  padding: 18px;
}

.lang-container {
  display: flex;
  align-items: flex-end;
  flex-wrap: wrap;
  flex-grow: 1;
  flex-direction: column-reverse;
  justify-content: space-between;
}

.sub-header {
  display: none;
  margin-right: 1em;
  margin-left: 1em;
}


@media screen and (min-width: 900px) {
  .lang-container {
    flex-direction: row;
    align-items: center;
  }
  .sub-header{
    display: block;
  }
  .spacer {
    display: block;
  }
}



h1{
  font-size: 36px;
}

h3 {
  white-space: nowrap;
  text-align: right;
  flex-grow: 100;
}


</style>
